<div class="flex flex-column relative mb-4 full-width outer-pagination" *ngIf="steps && steps.length">
    <div class="flex stepper-container">
        <div class="flex flex-grow relative step"
             *ngFor="let step of steps; let i = index;"
             [class.active]="currentStep === i"
             [class.visited]="i < currentStep"
             [class.future]="i > currentStep"
             (click)="onSetStep(i)"
             [tabindex]="i"
             (keydown.enter)="onSetStep(i)"
             [attr.data-index]="i"
        >
            <div class="flex align-center justify-center relative full-width">
                <span class="step-label" [innerHTML]="currentStep === i ? step.title || step.name : (i + 1)"></span>
                <div class="flex align-center justify-center stepper-icon" *ngIf="currentStep === i">
                    <i class="fa-solid {{ step.icon ?? 'fa-steering-wheel' }}" aria-hidden="true"></i>
                </div>
            </div>
        </div>
    </div>
</div>
